<template lang="pug">
  v-container(fluid)
    h2.text-center {{ translations.title }}
    v-row.px-2.px-sm-10.pb-10( justify="center")
      v-col(cols="12" md="12")
        v-expansion-panels
          v-expansion-panel
            v-expansion-panel-header {{ translations.filter.name }}
            v-expansion-panel-content
              v-container.pa-0(fluid)
                form
                  v-row
                    v-col.py-0(cols="12" sm="6")
                      BaseChipSelectField(:multiple="false", :items="operatorsListAll" v-model="filter.operator", :label="translations.filter.operator")
                    v-col.py-0(cols="12" sm="6")
                      v-menu(v-model="menu" offset-y transition="scale-transition" min-width="290px")
                        template(v-slot:activator="{on}")
                          v-text-field(v-model="filter.month"  v-on="on" readonly)
                            template(v-slot:label)
                              v-icon.pr-1(size="22") mdi-calendar
                              | {{ translations.filter.month }}
                        v-date-picker(v-model="filter.month" type="month" color="primary", :locale="$i18n.locale")
                    v-col.py-0.text-right(cols="12")
                      v-btn(@click="" text color="primary")
                        v-icon mdi-magnify
                        span {{ translations.filter.send }}
      v-col(cols="12").text-right
        v-btn(@click="ToCSV" color="green light-1" text)
          span {{ translations.button.downloadcsv }}
          v-icon.ml-4 mdi-download
      v-col(cols="12")
        v-data-table(
          :headers="headers"
          :items="datos"
          :items-per-page="30"
          :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}"
        )

</template>

<script>

  export default {
    name: "RTPIndex",
    data: () => ({
      namefilter: '',
      filter:{
        operator: null,
        month: ''
      },
      menu: false
    }),
    computed:{
      translations() {
        return this.$t("views.rtpIndex");
      },
      headers() {
        let headers = [
          {
            text: this.translations.tableHead.name,
            value: 'name'
          },
          {
            text: this.translations.tableHead.game,
            value: 'game'
          },
          {
            text: this.translations.tableHead.teoricRtp,
            value: 'teoricRTP'
          },
          {
            text: this.translations.tableHead.desktopRtp,
            value:'RTPDesktop'
          },
          {
            text: this.translations.tableHead.mobileRtp,
            value:'RTPMobile'
          }
        ];
        return headers;
      },
      datos(){
        return [
          {
            _id: '1',
            name: 'Emara Play',
            game: 'Test2',
            teoricRTP:'35%',
            RTPDesktop:'42%',
            RTPMobile:'40%',
          }]
      },
      operatorsListAll() {
        return this.$store.state.operators.map(operator => {
          return {
            text: operator.n,
            value: `${operator._id}`
          }
        }).sort((a, b) => a.text.localeCompare(b.text))
      },
      datosExport(){
        return this.datos.map(dato => {
          return {
            Name:dato.name,
            Game:dato.game,
            TeoricRTP:dato.teoricRTP,
            RTPDesktop:dato.RTPDesktop,
            RTPMobile:dato.RTPMobile
          }
        })
      }
    },
    created() {
      // const filterParams = {
      //   operator: '',
      //   month: ''
      // };
      this.$store.dispatch('getOperators');
      // this.$store.dispatch('getRtp', filterParams);  //TODO
    },
    methods:{
      ToCSV(){
        let csvContent = "data:text/csv;charset=utf-8,";
        csvContent += [
          Object.keys(this.datosExport[0]).join(";"),
          ...this.datosExport.map(item => Object.values(item).join(";"))
        ]
          .join("\n")
          .replace(/(^\[)|(\]$)/gm, "");

        const data = encodeURI(csvContent);
        const link = document.createElement("a");
        const date = new Date();
        const todayDate = `${date.getFullYear()}-${date.getMonth()}-${date.getDay()}`;
        link.setAttribute("href", data);
        link.setAttribute("download", `RTP ${todayDate}.csv`);
        link.click();
      },
      // search(){  //TODO
      //   let filterParams = {
      //     operator: this.filter.operator != null ? this.filter.operator.value : '',
      //     month: this.filter.month,
      //   };
      //   this.$store.dispatch('getRtp', filterParams);  //TODO
      // },
    }
  }
</script>

<style lang="sass">
</style>